import zh from './zh.json'

export default { zh }
